import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchVisitAssessmentAreas = async ({ visitId, patientId, sessionId, stepId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (patientId) params.append("patient_id", patientId);
  if (sessionId) params.append("session_id", sessionId);
  if (stepId) params.append("step_id", stepId);

  const res = await axios.get(
    `${__API_URL__}/api/photos/visits/${visitId}/assessment-areas/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useGetVisitAssessmentAreas = ({ visitId, patientId, sessionId, stepId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_assessment_areas", visitId, patientId, sessionId, stepId],
    queryFn: () => fetchVisitAssessmentAreas({ visitId, patientId, sessionId, stepId }),
    enabled: enabled && Boolean(visitId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load visit assessment areas");
    },
  });
};

export default useGetVisitAssessmentAreas;
